var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"title",on:{"click":_vm.closeColorCommands}},[_c('h2',[_vm._v(_vm._s(_vm.colorHex))]),_c('h3',[_vm._v(_vm._s(_vm.colorName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }